export default "__VITE_ASSET__DMh$XOXJ__"